// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Zfxdj","item":"styles_item__wTgtR","activeSwitch":"styles_activeSwitch__2tzFV"};